export default "__VITE_ASSET__10a0677c__"